
import { Component, ChangeDetectionStrategy, input, output, computed } from '@angular/core';
import { CommonModule, JsonPipe } from '@angular/common';

export type ThemeColor = 'blue' | 'pink' | 'lime' | 'cyan' | 'teal' | 'red' | 'purple' | 'emerald' | 'amber' | 'indigo';

@Component({
  selector: 'app-diagnostic-test-card',
  standalone: true,
  imports: [CommonModule, JsonPipe],
  templateUrl: './diagnostic-test-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiagnosticTestCardComponent {
  title = input.required<string>();
  scenario = input.required<string>();
  icon = input.required<string>(); // e.g., 'fa-solid fa-file-invoice-dollar'
  theme = input<ThemeColor>('blue');
  steps = input.required<string[]>();
  isRunning = input.required<boolean>();
  result = input<any | null>(null);
  
  runTest = output<void>();

  // Style mappings to ensure Tailwind classes are detected and valid
  private themeMap: Record<ThemeColor, { iconBg: string, iconBorder: string, iconText: string, btnBg: string, btnHover: string }> = {
    blue:    { iconBg: 'bg-blue-900/50',    iconBorder: 'border-blue-500/30',    iconText: 'text-blue-400',    btnBg: 'bg-blue-600',    btnHover: 'hover:bg-blue-500' },
    pink:    { iconBg: 'bg-pink-900/50',    iconBorder: 'border-pink-500/30',    iconText: 'text-pink-400',    btnBg: 'bg-pink-600',    btnHover: 'hover:bg-pink-500' },
    lime:    { iconBg: 'bg-lime-900/50',    iconBorder: 'border-lime-500/30',    iconText: 'text-lime-400',    btnBg: 'bg-slate-800',   btnHover: 'hover:bg-slate-700' }, // Lime buttons look better dark
    cyan:    { iconBg: 'bg-cyan-900/50',    iconBorder: 'border-cyan-500/30',    iconText: 'text-cyan-400',    btnBg: 'bg-cyan-600',    btnHover: 'hover:bg-cyan-500' },
    teal:    { iconBg: 'bg-teal-900/50',    iconBorder: 'border-teal-500/30',    iconText: 'text-teal-400',    btnBg: 'bg-teal-600',    btnHover: 'hover:bg-teal-500' },
    red:     { iconBg: 'bg-red-900/50',     iconBorder: 'border-red-500/30',     iconText: 'text-red-400',     btnBg: 'bg-red-600',     btnHover: 'hover:bg-red-500' },
    purple:  { iconBg: 'bg-purple-900/50',  iconBorder: 'border-purple-500/30',  iconText: 'text-purple-400',  btnBg: 'bg-purple-600',  btnHover: 'hover:bg-purple-500' },
    emerald: { iconBg: 'bg-emerald-900/50', iconBorder: 'border-emerald-500/30', iconText: 'text-emerald-400', btnBg: 'bg-emerald-600', btnHover: 'hover:bg-emerald-500' },
    amber:   { iconBg: 'bg-amber-900/50',   iconBorder: 'border-amber-500/30',   iconText: 'text-amber-400',   btnBg: 'bg-amber-600',   btnHover: 'hover:bg-amber-500' },
    indigo:  { iconBg: 'bg-indigo-900/50',  iconBorder: 'border-indigo-500/30',  iconText: 'text-indigo-400',  btnBg: 'bg-indigo-600',  btnHover: 'hover:bg-indigo-500' },
  };

  styles = computed(() => this.themeMap[this.theme()]);
}
